import React from 'react';
import { Button } from 'antd';
import type { TCredentialingActionItem } from 'types/credentialing';
import { SvgAlert } from '../SvgIcons';
import s from './s.module.less';

export interface ChecklistGroup {
    payer: string;
    state?: string;
    items: { reason: string; actionItem?: TCredentialingActionItem }[];
}

interface Props {
    title: string;
    subtitle: string;
    groups: ChecklistGroup[];
    onItemAction?: (item: TCredentialingActionItem) => void;
}

const ChecklistCard = ({ title, subtitle, groups, onItemAction }: Props) => {
    const total = groups.reduce((sum, g) => sum + g.items.length, 0);
    const grouped = groups.length > 1;
    return (
        <div className={s.checklistCard}>
            <div className={s.checklistHeader}>
                <div className={s.checklistHeaderLeft}>
                    <div className={s.iconWrap}><SvgAlert /></div>
                    <div className={s.checklistHeaderBody}>
                        <div className={s.titleText}>{title}</div>
                        <div className={s.subtitleText}>{subtitle}</div>
                    </div>
                </div>
                <span className={s.checklistCount}>0 of {total} done</span>
            </div>
            {groups.map((g, gi) => (
                <React.Fragment key={gi}>
                    {grouped && (
                        <div className={`${s.checklistGroupHeader}${gi > 0 ? ` ${s.withBorder}` : ''}`}>
                            <span className={s.checklistGroupName}>
                                {g.payer}
                                {g.state && <span className={s.checklistGroupState}> &middot; {g.state}</span>}
                            </span>
                            <span className={s.checklistGroupCount}>{g.items.length} item{g.items.length > 1 ? 's' : ''}</span>
                        </div>
                    )}
                    {g.items.map((it, ii) => {
                        const showBorder = grouped ? ii > 0 : gi > 0 || ii > 0;
                        return (
                            <div key={ii} className={`${s.checklistRow}${showBorder ? ` ${s.withBorder}` : ''}`}>
                                <div className={s.bodyWrap}>
                                    <div className={s.titleText}>{it.reason}</div>
                                </div>
                                <Button
                                    type="primary"
                                    className={s.updateBtn}
                                    onClick={() => it.actionItem && onItemAction?.(it.actionItem)}
                                >
                                    Update
                                </Button>
                            </div>
                        );
                    })}
                </React.Fragment>
            ))}
        </div>
    );
};

export default ChecklistCard;
